import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import React, { CSSProperties } from 'react';
import { IStyle } from 'Styles';
import './styles.scss';
interface CheckBoxProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  label?: string;
  mainContainerStyle?: CSSProperties;
  labelStyle?: CSSProperties;
  checkboxIconClass?: string;
  indeterminate?: boolean;
}

function CustomCheckBox(props: CheckBoxProps) {
  const {
    checked,
    disabled = false,
    indeterminate = false,
    label,
    mainContainerStyle,
    labelStyle,
    onClick,
    checkboxIconClass,
    onChange,
    ...rest
  } = props;

  const changeHandler = (e) => {
    if (!disabled && onChange) {
      onChange(e);
    }
  };

  const clickHandler = (e) => {
    if (!disabled && onClick) {
      onClick(e);
    }
  };

  return (
    <div
      id="customcheckbox-wrapper"
      {...(label && { style: { ...styles.mainContainer, ...mainContainerStyle } })}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <label id="customcheckbox-label" className="custom-checkbox-main-container">
        <input
          id="customcheckbox-input"
          type="checkbox"
          className="custom-checkbox-input"
          onChange={changeHandler}
          onClick={clickHandler}
          {...rest}
        />
        {indeterminate ? (
          <span className="relative inline-flex after:pointer-events-none after:absolute after:left-1 after:right-1 after:top-1/2 after:h-0.5 after:-translate-y-1/2 after:bg-white after:content-['']">
            <RMSvgIcon
              id="customcheckbox-svg-checkmark-icon"
              name="checkMark"
              fill="transparent"
              className={`checkbox !border-[#999999] !bg-[#999999] ${
                disabled && 'checkbox--disable'
              } ${checkboxIconClass}`}
            />
          </span>
        ) : (
          <RMSvgIcon
            id="customcheckbox-svg-checkmark-icon"
            name="checkMark"
            fill={!checked && disabled ? 'transparent' : 'white'}
            className={`checkbox ${checked && 'checkbox--active'}
             ${disabled && 'checkbox--disable'} ${checkboxIconClass}`}
          />
        )}
      </label>
      {label && (
        <div
          id={`customcheckbox-${label}`}
          style={labelStyle ? labelStyle : styles.LabelTextStyle}
        >
          {label}
        </div>
      )}
    </div>
  );
}

const styles: IStyle = {
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  LabelTextStyle: {
    fontWeight: 400,
    fontSize: 18,
    color: '#4F4F4F',
    marginLeft: '0.75rem',
  },
};
export default CustomCheckBox;
